<template>
  <div class="notice-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 创建 弹层 -->
    <Modal v-model="showCreatTypeModal"
           :title="title"
           @on-ok="createType()"
           :loading="loading">
      <Form :model="cate"
            action="javascript:void(0)">
        <FormItem label="管理区域">
          <Input v-model="cate.position"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
    
    <script>
export default {
  name: "notice-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      title: "添加",
      cate: {
        position: "",
      },
      formItem: {},
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "区域",
          key: "position",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 130,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "布置货架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      showCreatTypeModal: false,
      currentId: 0 // 编辑，当前id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {},
  methods: {
    getTableList: function () {
      var self = this;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.baixingqiang.arealist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.showCreatTypeModal = true;
      this.currentId = 0;
      this.title = "添加";
      this.cate.position = "";
    },
    // 编辑
    editType: function (id) {
      this.title = "编辑";
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.$api.baixingqiang.areadetail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate = res.result;
        }
      });
    },
    // 提交
    createType: function (name) {
      let params = {
        position: this.cate.position,
      };
      if (
        this.currentId == null ||
        this.currentId == 0 ||
        this.currentId == ""
      ) {
        this.$api.baixingqiang.areacreate(params).then(res => {
          if (res.code == 200) {
            this.showCreatTypeModal = false;
            this.getTableList();
          }
        });
      } else {
        params.id = this.currentId;
        this.$api.baixingqiang.areaedit(params).then(res => {
          if (res.code == 200) {
            this.showCreatTypeModal = false;
            this.getTableList();
          }
        });
      }
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
      this.showCreatTypeModal = false;
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该？</p>",
        onOk: () => {
          this.$api.baixingqiang
            .arearemove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.baixingqiang.arealist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
    </script>
    
    
  